import { concatSeriesFromDifferentRequestVisitor as concatSeriesFromDifferentRequestVisitorFunc } from "./concatSeriesFromDifferentRequestVisitor";
import { copyTotalSeriesIntoRowsSeriesVisitor as copyTotalSeriesIntoRowsSeriesVisitorFunc } from "./copyTotalSeriesIntoRowsSeriesVisitor";
import { filterTotalsByMostRecentDateVisitor as filterTotalsByMostRecentDateVisitorFunc } from "./filterTotalsByMostRecentDateVisitor";
import { insertDatapointsFromDifferentRequestVisitor as insertDatapointsFromDifferentRequestVisitorFunc } from "./insertDatapointsFromDifferentRequestVisitor";
import { mergeDatapointsFromDifferentRequestVisitor as mergeDatapointsFromDifferentRequestVisitorFunc } from "./mergeDatapointsFromDifferentRequestVisitor";
export var MultiRequestVisitorEnum;
(function (MultiRequestVisitorEnum) {
    MultiRequestVisitorEnum["concatSeriesFromDifferentRequestVisitor"] = "concatSeriesFromDifferentRequestVisitor";
    MultiRequestVisitorEnum["filterTotalsByMostRecentDateVisitor"] = "filterTotalsByMostRecentDateVisitor";
    MultiRequestVisitorEnum["copyTotalSeriesIntoRowsSeriesVisitor"] = "copyTotalSeriesIntoRowsSeriesVisitor";
    MultiRequestVisitorEnum["insertDatapointsFromDifferentRequestVisitor"] = "insertDatapointsFromDifferentRequestVisitor";
    MultiRequestVisitorEnum["mergeDatapointsFromDifferentRequestVisitor"] = "mergeDatapointsFromDifferentRequestVisitor";
})(MultiRequestVisitorEnum || (MultiRequestVisitorEnum = {}));
export const MultiRequestVisitors = {
    [MultiRequestVisitorEnum.concatSeriesFromDifferentRequestVisitor]: {
        visitor: concatSeriesFromDifferentRequestVisitorFunc
    },
    [MultiRequestVisitorEnum.filterTotalsByMostRecentDateVisitor]: {
        visitor: filterTotalsByMostRecentDateVisitorFunc
    },
    [MultiRequestVisitorEnum.copyTotalSeriesIntoRowsSeriesVisitor]: {
        visitor: copyTotalSeriesIntoRowsSeriesVisitorFunc
    },
    [MultiRequestVisitorEnum.insertDatapointsFromDifferentRequestVisitor]: {
        visitor: insertDatapointsFromDifferentRequestVisitorFunc
    },
    [MultiRequestVisitorEnum.mergeDatapointsFromDifferentRequestVisitor]: {
        visitor: mergeDatapointsFromDifferentRequestVisitorFunc
    }
};
